import Brett from "./Brett";
import Griff from "./Griff";
import Maths3 from "oc-threejs/Maths3";
import {v3} from "oc-threejs/short3";
import Tuer from "./Tuer";
import TuerFluegelO3 from "../object3d/TuerFluegel";
import Topfband from "./Topfband";
import Spiegel from "./Spiegel";
import Commons from "oc-commons/Commons";
import type {HasLocalCoordinates} from "./HasLocalCoordinates";

export default class TuerFluegel implements HasLocalCoordinates {

    tuer: Tuer;

    front: Brett;
    griff: ?Griff;
    topfbaender: Topfband[] = [];

    object3d: ?THREE.Object3D;
    position = new THREE.Vector3();
    quaternion = new THREE.Quaternion();

    get parent() {
        return this.tuer;
    }

    get element() {
        return this.tuer.element;
    }

    get schrank() {
        return this.tuer.schrank;
    }

    get interieur() {
        return this.tuer;
    }

    get material() {
        return this.tuer.getMaterial();
    }

    get doppeltuer() {
        return this.tuer.getSide() === 'beide';
    }

    get child3dContainer() {
        return this.object3d;
    }

    constructor(tuer) {
        this.tuer = tuer;
        this.front = new Brett(this, this.tuer.product.Artikelnummer, 'yx');
        this.spiegelbasis = new Brett(this, this.tuer.product.Artikelnummer, 'yx');
        this.spiegel = new Spiegel(this, this.spiegelbasis);
        // this.front.wireframe = true;
    }

    schrankToLocal(v: THREE.Vector3) {
        return this.tuer.schrankToLocal(v);
    }

    localToSchrank(v: THREE.Vector3) {
        return this.tuer.localToSchrank(v);
    }

    localToSchrankBox(box) {
        return new THREE.Box3(
            this.localToSchrank(box.min),
            this.localToSchrank(box.max)
        );
    }

    compileFront() {
        this.showClosed(true, 0);
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new TuerFluegelO3(this);
            this.tuer.child3dContainer.add(o3);
            return o3;
        });
        this._compileFront();
        this._compileGriff();
        this._compileTopfband();
        this.showClosed(this.tuer.isClosed, 0);
    }


    _compileFront() {
        const zOffset = APP.settings.getFloat('aussenwand_vorsprung')==0.0
            ? 0
            : - APP.settings.getFloat('aussenwand_vorsprung')

        switch (this.material) {
            case 'spiegel':
                this._compileFrontBrett(this.front, {
                    material: null,
                    staerke: APP.settings.getFloat('front_staerke'),
                    zOffset: zOffset,
                    rand: 0,
                });
                this._compileFrontBrett(this.spiegelbasis, {
                    material: 'spiegel',
                    staerke: APP.settings.getFloat('tuer_spiegel_dicke'),
                    zOffset: zOffset+APP.settings.getFloat('front_staerke'),
                    rand: APP.settings.getFloat('tuer_spiegel_abstand'),
                });
                this.spiegel.compile();
                break;
            case 'glas':
                this._compileFrontBrett(this.front, {
                    material: 'glas',
                    staerke: APP.settings.getFloat('tuer_glas_dicke'),
                    zOffset: zOffset,
                    rand: 0,
                });
                break;
            default:
                this._compileFrontBrett(this.front, {
                    material: null,
                    staerke: APP.settings.getFloat('front_staerke'),
                    zOffset: zOffset,
                    rand: 0,
                });
                break;
        }
    }

    _compileFrontBrett(brett, options) {
        const deckelstaerke = APP.settings.getFloat('deckel_staerke');
        const ueberstandOben = APP.settings.getFloat('ueberstand_aussen_oben');
        const fuge = APP.settings.getMinValue('fugen_abstand');

        if (options.material) {
            brett.fixedMaterialKey = options.material;
        }

        const boxLocal = this.tuer.boxLocal;
        brett.box.copy(boxLocal);
        brett.box.min.z = boxLocal.max.z + options.zOffset;
        brett.box.max.z = boxLocal.max.z + options.zOffset + options.staerke;
        if (this.element) {
            if (this.element.unverdeckt.linksVerdeckt) {
                brett.box.min.x = this.tuer.schrankToLocal(this.element.unverdeckt.box.min).x + options.rand;
            } else {
                brett.box.min.x = this.tuer.getFrontUeberstand(this.element.wallLeft, 'min', 'x') + options.rand;
            }
            if (this.element.unverdeckt.rechtsVerdeckt) {
                brett.box.max.x = this.tuer.schrankToLocal(this.element.unverdeckt.box.max).x - options.rand;
            } else {
                brett.box.max.x = this.tuer.getFrontUeberstand(this.element.wallRight, 'max', 'x') - options.rand;
            }
            this._handleDoppeltuerFluegel(brett, fuge, options.rand);
            if (this.tuer.boden.bottom) {
                const boxWorld = this.localToSchrankBox(brett.box);
                brett.box.min.y = this.tuer.getFrontUeberstand(this.tuer.boden.bottom, 'min', 'y') + options.rand;
                if (this.myTopIsSloped(boxWorld)) {
                    const ueberstand = deckelstaerke - ueberstandOben;
                    const maxYWorld = this.schrank.slopings.yOfX(boxWorld.max.x, ueberstandOben);
                    brett.box.max.y = maxYWorld - this.tuer.box.min.y - options.rand;
                    brett.boxToVertices();
                    brett.zEdgeXY(0, 1).y = this.schrank.slopings.yOfX(boxWorld.min.x, ueberstandOben) - this.tuer.box.min.y - options.rand;
                    if (this.schrank.slopings.isBroken(boxWorld)) {
                        brett.zEdgeXY(2, 1)._ = {
                         
                            x: this.schrank.slopeX - this.tuer.box.min.x,
                            y: this.tuer.box.max.y + ueberstand - this.tuer.box.min.y - options.rand
                        };
                    }
                    brett.updateBox();
                } else {
                    if (!this.tuer.boden.top) {
                        APP.model.maybeThrowCompileError(this,'compileError', 'dialogInteriorMinHeight', this.tuer.product.Name, this.tuer.box.max.y);
                    } else {
                        brett.box.max.y = this.tuer.getFrontUeberstand(this.tuer.boden.top, 'max', 'y') - options.rand;
                    }
                    brett.boxToVertices();
                }
            }
        } else {
            this._handleDoppeltuerFluegel(brett, fuge, options.rand);
            brett.boxToVertices();
        }
        brett.compile();
    }

    _handleDoppeltuerFluegel(brett, fuge, rand) {
        if (this.doppeltuer) {
            const center = brett.box.getCenter();
            if (this.side == 'rechts') {
                brett.box.min.x = center.x + fuge / 2 + rand;
            } else {
                brett.box.max.x = center.x - fuge / 2 - rand;
            }
        }
    }

    _compileTopfband() {
        const lazyTopfbaender = APP.model.lazyPool(this, 'topfbaender', () => new Topfband(this));
        if (this.material === 'glas') {
            const dicke = APP.settings.getFloat('tuer_topfband_dicke');
            const durchmesser = APP.settings.getFloat('tuer_topfband_durchmesser');
            const hoehen = APP.settings.getValue('tuer_anzahl_topfbaender').split(":");

            const abstand = APP.settings.getFloat('tuer_topfband_abstand_horizontal');
            let n = 2;
            const size = this.front.box.getSize();
            for (let i = 0; i < hoehen.length; i++) {
                if (parseFloat(hoehen[i]) > size.y) break;
                n++;
            }

            let x = this.side == 'rechts' ?
                // this.tuer.box.size.x ist die Innenbreite des Elementes (=der Türbox)
                this.tuer.box.max.x - this.tuer.box.min.x - abstand - durchmesser / 2 :
                // this.front.box: x=0 ist der linke Innenpunkt des Elementes (der Türbox)
                0 + abstand + durchmesser / 2
            if (this.tuer.element) {
                const elementBox = this.tuer.getElementBox(this.tuer.element);
                let x = this.side == 'rechts' ? (elementBox.max.x - abstand - durchmesser / 2) : (elementBox.min.x + abstand + durchmesser / 2)
            }
            let y0 = APP.settings.getFloat('tuer_topfband_abstand_vertikal');
            let dy = (size.y - durchmesser - 2 * APP.settings.getFloat('tuer_topfband_abstand_vertikal')) / (n - 1)

            for (let i = 0; i < n; i++) {
                const topfband = lazyTopfbaender.next();
                let y = y0 + i * dy;
                topfband.position.set(x, y, this.front.box.min.z - dicke / 2);
                topfband.compile();
            }
        }
        lazyTopfbaender.cleanup();
    }

    myTopIsSloped(boxWorld) {
        return this.schrank.slopings.isSloped(boxWorld) && (!this.tuer.boden.top || !this.tuer.boden.top.isInner)
    }


    _compileGriff() {

        const countTueren = elemente => elemente.reduce((acc,e)=>acc+Commons.count(e.interieurs,i=>i instanceof Tuer),0);
        const anzahlTuerenVerdeckeSelbst = this.element==null ? 0 : (this.element.verdecktAnderenSchrank ? countTueren(this.element.verdecktAnderenSchrank.elemente) : 0);
        const anzahlTuerenWerdeVerdeckt = this.element==null ? 0 : countTueren(this.element.verdecktVonElementen);

        let needsGriff = true;
        if (this.arrangement.isSchwebetuer()) {
            needsGriff = false;
        }

        if (needsGriff && this.griff==null) {
            this.griff = new Griff(this);
        } else if (!needsGriff && this.griff!=null) {
            this.griff = null;
        }
        if (this.griff) {
            this.griff.griffArtikelnummer = anzahlTuerenVerdeckeSelbst === 0 ? null : 'EckschrankLasche';
            this.griff.quaternion.copy(Maths3.quaternion.z90);
            this._compileGriffPosition();
            this.griff.compile();
        }
    }

    ecktuerOhneGriff() {
        return this.griff && this.griff.griffArtikelnummer=='EckschrankLasche';
    }

    _compileGriffPosition() {
        const xPosition = this.side == 'rechts' ? 0 : this.front.box.max.x;

        const idealTuerGriffHoehe = this.tuer.schrankToLocal(v3(0, APP.settings.getMinValue('tuer_griff_hoehe'), 0)).y;
        const wunschPosition = v3(xPosition, idealTuerGriffHoehe, 0);

        // Beachtung von Rahmenabstand
        const mindestAbstand = v3(APP.settings.getMinValue('tuer_griff_abstand_horizontal'), APP.settings.getMinValue('tuer_griff_abstand_vertikal'), 0);
        mindestAbstand.add(this.griff.getBoundingBoxLocal().getSize().multiplyScalar(0.5));
        const griffBoxAllowedXY = this.front.box.clone();
        if (this.tuer.element && this.tuer.element.sloped) {
            const brettstaerke = APP.settings.getFloat('front_staerke');
            const leftY = this.schrank.slopings.yOfX(this.element.box.min.x, brettstaerke) - this.tuer.box.min.y
            const rightY = this.schrank.slopings.yOfX(this.element.box.max.x, brettstaerke) - this.tuer.box.min.y
            griffBoxAllowedXY.max.y = Math.min(leftY, rightY, griffBoxAllowedXY.max.y);
        }
        griffBoxAllowedXY.expandByVector(mindestAbstand.multiplyScalar(-1));
        const newPos = griffBoxAllowedXY.clampPoint(wunschPosition);
        newPos.z = this.front.box.max.z;
        this.griff.position.copy(newPos);
    }

    showClosed(close, time) {
        const animationType = APP.settings.getValue('tuer_animation', 'rotate').toLowerCase();
        if (animationType === 'fade') {
            if (this.object3d) {
                this.object3d.animate({
                    opacity: close ? 1 : 0,
                    duration: time,
                    onStart: () => {
                        this.object3d.visible = !close;
                    },
                    onComplete: () => {
                        this.object3d.visible = close;
                    },
                });
            }
        } else {
            const verdeckungsTuerExists = this.arrangement.getInterieurs().some(i=>i instanceof Tuer && i.element.verdecktAnderenSchrank);
            const isWideAngle = this.tuer.element && (this.tuer.element.verdecktVonElementen.length>0 || this.tuer.element.verdecktAnderenSchrank);
            const w = APP.settings.getFloat('tuer_drehung_winkel');
            const winkel = isWideAngle ? 180-w : w;
            const angle = (close ? 0 : winkel) * (this.side == 'rechts' ? 1 : -1);

            const drehpunkt = APP.settings.getValue('tuer_drehung_punkt').split(':').map(c => parseFloat(c));

            const origin = new THREE.Vector3(
                this.side == 'rechts' ? this.front.box.max.x + drehpunkt[0] : this.front.box.min.x-drehpunkt[0],
                0,
                this.front.box.max.z + drehpunkt[1]);

            if (this.object3d) {
                const times = close && verdeckungsTuerExists ? [0,time] : [time,0];
                this.object3d.animate({
                    delay: this.tuer.element && this.tuer.element.verdecktAnderenSchrank ? times[0] : times[1],
                    rotate: angle / 180 * Math.PI,
                    origin: this.front.object3d.localToWorld(origin),
                    axis: new THREE.Vector3(0, 1, 0),
                    duration: time,
                });
            }
        }
    }

    iterate(iterator) {
        iterator(this);
        this.front && iterator(this.front);
        this.griff && iterator(this.griff);
        this.topfbaender && iterator(this.topfbaender);
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

}
